<template>
  <li :data-noteid="note.id">  
    <div class="left">
      <!-- BEGIN Note Action !-->
      <div class="checkbox check-warning no-margin">
        <input id="qncheckbox1" type="checkbox" value="1">
        <label for="qncheckbox1"></label>
      </div>
      <!-- END Note Action !-->
      <!-- BEGIN Note Preview Text !-->
      <p class="note-preview">{{ note.preview }}</p>
      <!-- BEGIN Note Preview Text !-->
    </div>
    <!-- BEGIN Note Details !-->
    <div class="right pull-right">
      <!-- BEGIN Note Date !-->
      <span class="date">{{ note.date }}</span>
      <a href="#" data-navigate="view" data-view-port="#note-views" data-view-animation="push"><i class="fa fa-chevron-right"></i></a>
      <!-- END Note Date !-->
    </div>
    <!-- END Note Details !-->
  </li>
</template>

<script> 
  export default {
    name: "Note",
    props: {
      note: {
        type: Object,
        default: {}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// note.vue?e7c5b65a